

<template>
  <div>
    <!--    Breadcrumb Section Component-->
    <breadcrumb :breadcrumb="breadcrumb"/>
    <!--    About Section Component-->
    <about-area/>
    <!--    Choose Section Component-->
    <choose-area/>
    <!--    Testimonial Section Component-->
    <testimonial-area/>
    <!--    Delivery Section Component-->
    <delivery-area/>
    <!--    Offer Section Component-->
    <offer-area/>
  </div>
</template>
<script>
import Breadcrumb from "../components/Breadcrumb";
import ChooseArea from "../components/ChooseArea";
import TestimonialArea from "../components/TestimonialArea";
import DeliveryArea from "../components/DeliveryArea";
import OfferArea from "../components/OfferArea";
import AboutArea from "../components/AboutArea";

export default {
  name: 'AboutUs',
  components: {AboutArea, OfferArea, DeliveryArea, TestimonialArea, ChooseArea, Breadcrumb},
  data() {
    return {
      breadcrumb: {
        title: 'About Us',
        link: 'About Us'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/AboutUs.vue